// slides
export const SLIDES_GET_ALL_SLIDES = 'SLIDES_GET_ALL_SLIDES'
export const SLIDES_ADD_NEW_SLIDE = 'SLIDES_ADD_NEW_SLIDE'
export const SLIDES_UPDATE_SLIDE = 'SLIDES_UPDATE_SLIDE'
export const SLIDES_DELETE_SLIDE = 'SLIDES_DELETE_SLIDE'
// about
export const ABOUT_GET_INFO_ABOUT = 'ABOUT_GET_INFO_ABOUT'
export const ABOUT_UPDATE_INFO_ABOUT = 'ABOUT_UPDATE_INFO_ABOUT'
export const GALLERY_UPDATE_IMAGES = 'GALLERY_UPDATE_IMAGES'
// services
export const SERVICES_GET_ALL_SERVICES = 'SERVICES_GET_ALL_SERVICES'
export const SERVICES_ADD_NEW_SERVICE = 'SERVICES_ADD_NEW_SERVICE'
export const SERVICES_UPDATE_SERVICE = 'SERVICES_UPDATE_SERVICE'
export const SERVICES_DELETE_SERVICE = 'SERVICES_DELETE_SERVICE'
// projects
export const PROJECTS_GET_ALL_PROJECTS = 'PROJECTS_GET_ALL_PROJECTS'
export const PROJECTS_ADD_NEW_PROJECT = 'PROJECTS_ADD_NEW_PROJECT'
export const PROJECTS_UPDATE_PROJECT = 'PROJECTS_UPDATE_PROJECT'
export const PROJECTS_DELETE_PROJECT = 'PROJECTS_DELETE_PROJECT'
// members
export const MEMBERS_GET_ALL_MEMBERS = 'MEMBERS_GET_ALL_MEMBERS'
export const MEMBERS_ADD_NEW_MEMBER = 'MEMBERS_ADD_NEW_MEMBER'
export const MEMBERS_UPDATE_MEMBER = 'MEMBERS_UPDATE_MEMBER'
export const MEMBERS_DELETE_MEMBER = 'MEMBERS_DELETE_MEMBER'